module.exports = __webpack_public_path__ + "img/DE05799.a1e73a2b.png";